import React, { useState } from 'react';
import './BackgroundVideo.scss';
// import Login from 'assets/images/general/login.jpg';
import ReactPlayer from 'react-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeMute, faVolumeUp } from '@fortawesome/free-solid-svg-icons';

function BackgroundVideo() {
    const [muted, setMuted] = useState(true);

    const handleUnmte = () => {
        setMuted(prev => !prev);
    };

    return (
        <div>
            <button
                className='sound-btn'
                onClick={handleUnmte}>
                {muted
                    ? <FontAwesomeIcon size='2x' icon={faVolumeMute} /> : <FontAwesomeIcon size='2x' icon={faVolumeUp} />
                }
            </button>
            <div className='video-background'>

                <ReactPlayer
                    config={{
                        youtube: {
                            playerVars: {
                                disablekb: 1
                            }
                        }
                    }}
                    controls={false}
                    light={false}
                    pip={false}
                    width={'100%'}
                    height={'100%'}
                    loop={true}
                    playing={true}
                    // volume={0}
                    muted={muted}
                    url='https://www.youtube.com/embed/wUYuUTlMcbg' />

            </div>
        </div>
    );
}

export default BackgroundVideo;
